<template>
  <el-dialog
    :visible.sync="show"
    :title="title"
    width="800px"
    :close-on-click-modal="false"
  >
  <!-- 租户名称 -->
    <el-row :span="24" type="flex" align="middle">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        租户名称：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.name"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>
    <!-- 国家 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        国家：
      </el-col>
      <el-col
        :span="16"
      >
      <el-select
          class="input250"
          v-model="detail.country"
          clearable
          @change="changeCountry"
          :disabled="user.role_id !== 1 || isView"
        >
          <el-option
            v-for="item in countries"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

<!-- 地址 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        地址：
      </el-col>
      <el-col
        :span="16"
      >
        <el-cascader
          :disabled="isView"
          v-model="addressData"
          :props="{
            label: 'name',
            value: 'code'
          }"
          popper-class="cascader-style"
          class="wid100p"
          :options="addressOptions"></el-cascader>
      </el-col>
    </el-row>
    <el-row :span="24" type="flex" align="middle" class="mt5">
      <el-col
        :offset="7"
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.address"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>
<!-- 授权方式 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        授权方式：
      </el-col>
      <el-col
        :span="16"
      >
        <el-radio-group
          :disabled="isView"
          v-model="detail.auth_type">
          <el-radio :label="1">有效期</el-radio>
          <el-radio :label="2">标签数量</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <!-- 医院规模 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >医院规模：</el-col>
      <el-col
        :span="16"
      >
        <el-select :disabled="isView" class="input250"  v-model="detail.scale" :placeholder="`请选择`">
          <el-option
            v-for="item in hospitalScale"
            :key="item.id"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- 医院科室数量 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >医院科室数量：</el-col>
      <el-col
        :span="16"
      >
        <el-input-number
          class="input250"
          v-model="detail.department_number"
          :min="1"
          :precision="0"
          :disabled="isView"
        ></el-input-number>
      </el-col>
    </el-row>

    <!-- 日均器械包处理数量 -->
    <el-row type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >日均器械包处理数量：</el-col>
      <el-col
        :span="16"
      >
        <el-input-number
          :disabled="isView"
          class="input250"
          v-model="detail.daily_instrumentset_number"
          :min="1"
          :precision="0"
        ></el-input-number>
      </el-col>
    </el-row>

    <!-- 日均标签数量 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >日均标签数量：</el-col>
      <el-col
        :span="16"
      >
        <el-input-number
          class="input250"
          v-model="detail.daily_label_number"
          :min="1"
          :precision="0"
          :disabled="isView"
        ></el-input-number>
      </el-col>
    </el-row>

    <!-- 标签数量 -->
    <el-row v-if="detail.auth_type === 2" :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right"
      >
        标签数量：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input-number
          class="input250"
          :disabled="isView"
          v-model="detail.total_tag"
          :min="0"
        ></el-input-number>
      </el-col>
    </el-row>

    <template v-if="detail.auth_type === 1">
      <el-row :span="24" type="flex" align="middle" class="mt20">
        <el-col
          :span="5"
          :offset="2"
          class="d-flex right"
        >
        开始日期：
        </el-col>
        <el-col
          :span="16"
        >
          <el-date-picker
            class="input250"
            :disabled="isView"
            v-model="detail.start_time"
            value-format="yyyy-MM-dd"
            type="date"
            :picker-options="{
              disabledDate: (date) => {
                return disabledDate(date)
              }
            }"
            :placeholder="`请选择`">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :span="24" type="flex" align="middle" class="mt20">
        <el-col
          :span="5"
          :offset="2"
          class="d-flex right"
        >
        结束日期：
        </el-col>
        <el-col
          :span="16"
        >
          <el-date-picker
            class="input250"
            :disabled="!detail.start_time || isView"
            v-model="detail.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            :picker-options="{
              disabledDate: (date) => {
                return disabledEndDate(date)
              }
            }"
            :placeholder="`请选择`">
          </el-date-picker>
        </el-col>
      </el-row>
    </template>
    <!-- 经销商 -->
    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right"
      >经销商名称：
      </el-col>
      <el-col
        :span="16"
      >
        <el-cascader :disabled="isView || user.role_id === 6" :props="cascaderProps" :options="options" v-model="detail.dealer_id_arr" clearable></el-cascader>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        状态：
      </el-col>
      <el-col
        :span="16"
      >
        <el-radio-group
          :disabled="isView"
          v-model="detail.status">
          <el-radio :label="1">正常</el-radio>
          <el-radio :label="2">冻结</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        合同类型：
      </el-col>
      <el-col
        :span="16"
      >
        <el-radio-group
          :disabled="isView"
          v-model="detail.contract_type">
          <el-radio :label="0">试用</el-radio>
          <el-radio :label="1">正式</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row v-show="detail.contract_type === 1" :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right required"
      >
        合同编号：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.contract_no"
          :placeholder="`请输入`"
          clearable
          @blur="validateContractNo(true)"
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right"
      >
        备注：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.remark"
          :placeholder="`请输入`"
          clearable
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="5"
        :offset="2"
        class="d-flex right"
      >
        上传照片：
      </el-col>
      <el-col
        :span="4"
      >
        <div class="photo-btn" @click="openPicturePicker">
          <i class="el-icon-camera-solid"></i>
        </div>
      </el-col>
      <el-col
        :span="4"
        class="d-flex center"
        v-show="detail.image"
      >
        <el-image
          :src="detail.image"
          class="logo-image"
          :preview-src-list="[ detail.image ]"
        ></el-image>
        <i
          v-if="!isView"
          class="el-icon-delete-solid ml5 fontsize20" 
          style="color: gray; cursor: pointer;"
          @click="delLogo"
        ></i>
      </el-col>
    </el-row>

    <div
      slot="footer"
      class="d-flex right"
    >
      <el-button
        size="small"
        @click="close"
      >关闭</el-button>
      <el-button
        v-show="!isView"
        size="small"
        type="primary"
        @click="save"
      >确定</el-button>
    </div>

    <PictureSelect ref="pictureSelect" @complete="getPicture" />
  </el-dialog>
</template>

<script>
import {
  mapGetters
} from 'vuex';
import store from '@/store';
import {
  tenantManage, dealerSelect
} from '@/api.js';
import {
    getAddressData
} from '@/requests/system'
export default {
  name: 'TenantManagementEdit',
  data() {
    return {
      cascaderProps:{
        label:'name',
        children:'children',
        value:'id',
        checkStrictly: true
      },
      options: [],
      show: false,
      isView: false,
      hospitalScale:[],
      detail: {
        name: '',
        address: '',
        auth_type: 1,
        status: 1,
        total_tag: 0,
        start_time: '',
        end_time: '',
        image: '',
        file_id: undefined,
        department_number:1,
        daily_instrumentset_number:1,
        daily_label_number:1,
        scale:'',
        dealer_id_arr:[],
        remark: '',
        contract_type: 0,
        country: undefined
      },
      addressData: [],
      addressOptions: []
    }
  },
  computed: {
    ...mapGetters(['system', 'user', 'countries']),
    mode() {
      // 新建或编辑
      const {
        id
      } = this.detail
      let mode = 'new'; // new or edit
      if (id && Number(id)) {
        mode = 'edit'
      } else {
        mode = 'new'
      }

      return mode
    },
    title() {
      let title = ''
      if (this.mode === 'new') {
        title = `新增`
      } else if (this.mode === 'edit') {
        title = `编辑`
      }

      if (this.isView) {
        title = `详情`
      }

      return title
    }
  },
  created(){
    this.getDicts()
    this.getDealerList()
  },
  methods: {
    getDealerList(){
      this.$request('get', dealerSelect)
      .then(res => {
        this.options = res
      })
    },
    getDicts() {
      this.$utils.getDict([608]).then(res => {
        if (res) {
          this.hospitalScale = res[608]
        }
      })
    },
    async open(config = {}) {
      this.reset()
      await store.dispatch('setCountries')
      const {
        detail,
        isView
      } = config

      if (!detail) {
        // 新建时默认国家
        this.defaultCountry()
        this.defaultDealer()
      }

      const assignedDetail = Object.assign({}, this.detail, detail)
      this.$set(this, 'detail', assignedDetail)

      if (detail && detail.country) {
        await this.getAddress(detail.country)
      }

      if(detail && detail.dealer_id){ // 找到经销商的父元素
        let haveChildren = false
        for (let i = 0; i < this.options.length; i++) {
          const dealer = this.options[i];
          if (dealer.children) {
            for (let j = 0; j < dealer.children.length; j++) {
              if (dealer.children[j].id === detail.dealer_id) {
                haveChildren = true
                this.detail.dealer_id_arr = [dealer.id, detail.dealer_id]
              }
            }
          }
        }
        if(!haveChildren){
          this.detail.dealer_id_arr = [detail.dealer_id]
        }
      }
      const { province, city, area } = this.detail
      this.addressData = province && city
      ?
      [province, city] 
      :
      []

      if (area) {
        this.addressData.push(area)
      }
      
      this.isView = !!isView

      this.show = true
    },
    openPicturePicker() {
      if (this.isView) return
      const {
        pictureSelect
      } = this.$refs

      pictureSelect && pictureSelect.show()
    },
    getPicture(pics) {
      if (!pics || !pics[0]) return
      
      this.detail.image = pics[0].fileUrl
      this.detail.file_id = pics[0].fileId
    },
    delLogo() {
      this.detail.image = ''
      this.detail.file_id = undefined
    },
    disabledDate(date) {
      // 不可选择的时间范围
      const datetime = this.$moment(date).unix() * 1000
      const { time : now } = this.system
      const todayStart = this.$moment(now).startOf('day')

      return datetime < todayStart
    },
    disabledEndDate(date) {
      // 不可选择的时间范围
      const datetime = this.$moment(date).unix() * 1000
      const startTime = this.detail.start_time
      const start = this.$moment(startTime).startOf('day')

      return datetime < start
    },
    reset() {
      this.detail = {
        id: undefined,
        name: '',
        address: '',
        auth_type: 1,
        status: 1,
        total_tag: 0,
        start_time: '',
        end_time: '',
        image: '',
        file_id: undefined,
        department_number:1,
        daily_instrumentset_number:1,
        daily_label_number:1,
        scale:'',
        remark: '',
        contract_type: 0,
        country: undefined
      },
      this.isView = false
      this.addressData = []
    },
    defaultCountry() {
      // 默认国家
      const {
        country,
        role_id
      } = this.user
      const defaultCountry = role_id === 6 ? country || 'CN' : 'CN'
      
      if (this.countries.map(i => i.code).includes(defaultCountry)) {
        this.$set(this.detail, 'country', defaultCountry)
      }

      this.$nextTick(() => {
        this.changeCountry(defaultCountry)
      })
    },
    defaultDealer() {
      // 默认经销商
      const {
        role_id,
        dealer_id
      } = this.user
      if (role_id === 6) {
        // 经销商账户情况下
        this.$set(this.detail, 'dealer_id', dealer_id)

        this.options.forEach(l1 => {
          if (l1.id === dealer_id) {
            this.detail.dealer_id_arr = [l1.id]
          } else if (l1.children) {
            l1.children.forEach(l2 => {
              if (l2.id === dealer_id) {
                this.detail.dealer_id_arr = [l1.id, l2.id]
              }
            })
          }
        })
      }
    },
    validateFields(params) {
      // 校验字段
      const {
        name,
        province,
        city,
        area,
        address,
        auth_type,
        start_time,
        end_time,
        scale,
        department_number,
        daily_instrumentset_number,
        daily_label_number,
        contract_no,
        contract_type
      } = params

      let msg = '';
      if (!name.trim()) {
        msg = `名称不能为空`
      } else if (!province || !city  || !address) {
        msg = `地址不能为空`
      } else if (!scale) {
        msg = `医院规模不能为空`
      } else if (!department_number) {
        msg = `医院科室数量不能为空`
      } else if (!daily_instrumentset_number) {
        msg = `日均器械包处理数量不能为空`
      } else if (!daily_label_number) {
        msg = `日均标签数量不能为空`
      } else if (auth_type === 1 && (!start_time || !end_time)) {
        msg = `时间不能为空`
      } else if (contract_type === 1 && !contract_no) {
        msg = `合同编号不能为空`
      } else if (this.validateContractNo()) {
        msg = this.validateContractNo()
      }
      

      if (msg) {
        this.$message.error(msg)
      }

      return !msg
    },
    validateContractNo(showPrompt = false) {
      // 校验合同编号
      let validateMsg = ''
      const { contract_no, contract_type } = this.detail
      if (contract_type !== 1) {
        return validateMsg
      }

      const regex = /^\d{4}-\d{2}-\d{2}-\d{4}$/
      const validateResult = regex.test(contract_no)
      if (!validateResult) {
        validateMsg = `合同编号格式错误`

        if (showPrompt) {
          // 为复用方法，增加是否显示提示的参数
          this.$message.error(validateMsg)
        }
      }

      return validateMsg
    },
    changeCountry(value) {
      this.addressData = []
      this.$nextTick(() => {
        this.addressOptions = []
        this.getAddress(value)
      })
    },
    getAddress(code) {
      if (!code) return

      return getAddressData(code)
      .then(res => {
        const addressOptions = res || []

        this.addressOptions = addressOptions
      })
    },
    save() {
      // 保存
      const {
        id,
        name,
        address,
        auth_type,
        status,
        start_time,
        end_time,
        total_tag,
        file_id,
        scale,
        department_number,
        daily_instrumentset_number,
        daily_label_number,
        dealer_id_arr,
        remark,
        contract_type,
        contract_no,
        country
      } = this.detail
      if(dealer_id_arr && dealer_id_arr.length != 0){
        var dealer_id = dealer_id_arr[dealer_id_arr.length - 1]
      }
      const province = this.addressData[0] || undefined
      const city = this.addressData[1] || undefined
      const area = this.addressData[2] || undefined
      const params = {
        id,
        name,
        auth_type,
        province,
        city,
        area,
        address,
        status,
        start_time: auth_type === 1 ? start_time : undefined,
        end_time: auth_type === 1 ? end_time : undefined,
        total_tag: auth_type === 2 ? total_tag : undefined,
        file_id,
        scale,
        department_number,
        daily_instrumentset_number,
        daily_label_number,
        dealer_id,
        remark,
        contract_type,
        contract_no: contract_type === 1 ? contract_no : undefined,
        country
      }
      const validate = this.validateFields(params)
      if (!validate) return

      this.$request('post', tenantManage, params)
      .then(res => {
        if (res) {
          this.$message.success(`操作成功`)
          this.notifyRefresh()
          this.close()
        }
      })
    },
    notifyRefresh() {
      this.$emit('fresh')
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo-btn {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: lightgray;
    border-radius: 4px;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 30px;
      vertical-align: middle;
    }
  }
  .logo-image {
    height: 60px;
    width: auto;
  }
</style>
<style lang="scss">
</style>